// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"033ae4e2","455":"eafbaac3","488":"5216ebc0","977":"1ddc0840"}[chunkId] + ".chunk.js";
};